/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { i as isWeb, a as isKuaiShouMiniProgram, b as isWeChatMiniProgram, c as isByteDanceMicroApp, d as isMiniApp, e as isBaiduSmartProgram } from '../../../index-892d8eee.js';

function isUndef(type) {
  return type === 'undefined';
}

var isDingdingMiniapp = !isUndef(typeof dd) && dd !== null && !isUndef(typeof dd.alert);

function _extends$2() { _extends$2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }

function promisify(api) {
  return function (arg) {
    return new Promise(function (resolve, reject) {
      var promisifyArg = arg;
      api(_extends$2({}, promisifyArg, {
        success: function success(res) {
          if (promisifyArg && typeof promisifyArg.success === 'function') {
            promisifyArg.success(res);
          }

          resolve(res);
        },
        onSuccess: function onSuccess(res) {
          if (promisifyArg && typeof promisifyArg.onSuccess === 'function') {
            promisifyArg.onSuccess(res);
          }

          resolve(res);
        },
        fail: function fail(res) {
          if (promisifyArg && typeof promisifyArg.fail === 'function') {
            promisifyArg.fail(res);
          }

          reject(res);
        },
        onFail: function onFail(res) {
          if (promisifyArg && typeof promisifyArg.onFail === 'function') {
            promisifyArg.onFail(res);
          }

          reject(res);
        },
        complete: function complete(res) {
          if (promisifyArg && typeof promisifyArg.complete === 'function') {
            promisifyArg.complete(res);
          }
        },
        onComplete: function onComplete(res) {
          if (promisifyArg && typeof promisifyArg.onComplete === 'function') {
            promisifyArg.onComplete(res);
          }
        }
      }));
    });
  };
}

var _excluded = ["_ext"];

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends$1() { _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }
var styleIn = function styleIn(options, baseName) {
  var _ref = options || {},
      _ref$_ext = _ref._ext,
      _ext = _ref$_ext === void 0 ? {} : _ref$_ext,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  return _extends$1({}, rest, _ext[baseName] || {});
};

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var styleOptions = function styleOptions(options, containerName) {
  var afterOptions = _extends({}, options);

  if (!afterOptions.frontColor) {
    afterOptions.frontColor = '#000000';
  }

  return afterOptions;
};
/**
 * setNavigationBarTitle api
 * @param api
 * @param containerName
 * @returns
 */


function normalizeSetNavigationBarTitle(api, containerName) {
  return function (args) {
    return promisify(api)(styleIn(args, containerName));
  };
}
/**
 * setNavigationBarColor api
 * @param api
 * @param containerName
 * @returns
 */

function normalizeSetNavigationBarColor(api, containerName) {
  return function (args) {
    return promisify(api)(styleOptions(styleIn(args, containerName)));
  };
} // export function normalizeGetMenuButtonBoundingClientRect(api: (args) => any, containerName: string) {
//   return (args?) => {
//     return promisify(api)(args);
//   };
// }

var CONTAINER_NAME = {
  WECHAT: 'wechatMiniProgram',
  ALIPAY: 'aliMiniApp',
  BYTE: 'bytedanceMicroApp',
  WEB: 'web',
  BAIDU: 'baiduSmartProgram',
  KWAI: 'kuaishouMiniProgram'
};

var setNavigationBarColor$4 = normalizeSetNavigationBarColor(function (args) {
  return isDingdingMiniapp ? dd.setNavigationBar(args) : my.setNavigationBar(args);
}, CONTAINER_NAME.ALIPAY);

var setNavigationBarTitle$b = normalizeSetNavigationBarTitle(function (args) {
  return isDingdingMiniapp ? dd.setNavigationBar(args) : my.setNavigationBar(args);
}, CONTAINER_NAME.ALIPAY);
var setNavigationBarTitle$c = setNavigationBarTitle$b;

var aliMiniAppModule = {
  setNavigationBarColor: setNavigationBarColor$4,
  setNavigationBarTitle: setNavigationBarTitle$c
};

/**
 * 动态设置当前页面的标题
 */

var setNavigationBarTitle$9 = normalizeSetNavigationBarTitle(function (_ref) {
  var title = _ref.title,
      _ref$success = _ref.success,
      success = _ref$success === void 0 ? function () {} : _ref$success,
      _ref$fail = _ref.fail,
      fail = _ref$fail === void 0 ? function () {} : _ref$fail,
      _ref$complete = _ref.complete,
      complete = _ref$complete === void 0 ? function () {} : _ref$complete;

  try {
    document.title = title;
    success();
    complete();
  } catch (error) {
    fail();
    complete();
  }
}, CONTAINER_NAME.WEB);
var setNavigationBarTitle$a = setNavigationBarTitle$9;

var webModule = {
  setNavigationBarTitle: setNavigationBarTitle$a
};

var setNavigationBarColor$3 = normalizeSetNavigationBarColor(function (args) {
  wx.setNavigationBarColor(args);
}, CONTAINER_NAME.WECHAT);

var setNavigationBarTitle$7 = normalizeSetNavigationBarTitle(function (args) {
  return wx.setNavigationBarTitle(args);
}, CONTAINER_NAME.WECHAT);
var setNavigationBarTitle$8 = setNavigationBarTitle$7;

// import { normalizeSetNavigationBarColor } from '../common';
// import { CONTAINER_NAME } from '@utils/constant';
// const getMenuButtonBoundingClientRect = normalizeSetNavigationBarColor((args) => {
//   wx.setNavigationBarColor(args);
// }, CONTAINER_NAME.WECHAT);
// export default getMenuButtonBoundingClientRect;
var getMenuButtonBoundingClientRect$3 = (function () {
  return wx.getMenuButtonBoundingClientRect();
});

var weChatModule = {
  setNavigationBarColor: setNavigationBarColor$3,
  setNavigationBarTitle: setNavigationBarTitle$8,
  getMenuButtonBoundingClientRect: getMenuButtonBoundingClientRect$3
};

var setNavigationBarColor$2 = normalizeSetNavigationBarColor(function (args) {
  tt.setNavigationBarColor(args);
}, CONTAINER_NAME.BYTE);

var setNavigationBarTitle$5 = normalizeSetNavigationBarTitle(function (args) {
  return tt.setNavigationBarTitle(args);
}, CONTAINER_NAME.BYTE);
var setNavigationBarTitle$6 = setNavigationBarTitle$5;

var getMenuButtonBoundingClientRect$2 = (function () {
  return tt.getMenuButtonBoundingClientRect();
});

var bytedanceModule = {
  setNavigationBarColor: setNavigationBarColor$2,
  setNavigationBarTitle: setNavigationBarTitle$6,
  getMenuButtonBoundingClientRect: getMenuButtonBoundingClientRect$2
};

var setNavigationBarColor$1 = normalizeSetNavigationBarColor(function (args) {
  ks.setNavigationBarColor(args);
}, CONTAINER_NAME.KWAI);

var setNavigationBarTitle$3 = normalizeSetNavigationBarTitle(function (args) {
  return ks.setNavigationBarTitle(args);
}, CONTAINER_NAME.KWAI);
var setNavigationBarTitle$4 = setNavigationBarTitle$3;

var getMenuButtonBoundingClientRect$1 = (function () {
  return ks.getMenuButtonBoundingClientRect();
});

var kuaiShouModule = {
  setNavigationBarColor: setNavigationBarColor$1,
  setNavigationBarTitle: setNavigationBarTitle$4,
  getMenuButtonBoundingClientRect: getMenuButtonBoundingClientRect$1
};

var setNavigationBarColor = normalizeSetNavigationBarColor(function (args) {
  swan.setNavigationBarColor(args);
}, CONTAINER_NAME.BAIDU);

var setNavigationBarTitle$1 = normalizeSetNavigationBarTitle(function (args) {
  return swan.setNavigationBarTitle(args);
}, CONTAINER_NAME.BAIDU);
var setNavigationBarTitle$2 = setNavigationBarTitle$1;

var getMenuButtonBoundingClientRect = (function () {
  return swan.getMenuButtonBoundingClientRect();
});

var baiDuModule = {
  setNavigationBarColor: setNavigationBarColor,
  setNavigationBarTitle: setNavigationBarTitle$2,
  getMenuButtonBoundingClientRect: getMenuButtonBoundingClientRect
};

var setNavigationBarTitle = function setNavigationBarTitle(args) {
  if (isWeb) {
    return webModule.setNavigationBarTitle(args);
  } else if (isKuaiShouMiniProgram) {
    return kuaiShouModule.setNavigationBarTitle(args);
  } else if (isWeChatMiniProgram) {
    return weChatModule.setNavigationBarTitle(args);
  } else if (isByteDanceMicroApp) {
    return bytedanceModule.setNavigationBarTitle(args);
  } else if (isMiniApp) {
    return aliMiniAppModule.setNavigationBarTitle(args);
  } else if (isBaiduSmartProgram) {
    return baiDuModule.setNavigationBarTitle(args);
  } else {
    throw new Error('Uni API：setNavigationBarTitle暂不支持');
  }
};

var mini = setNavigationBarTitle;

export { mini as default };
